module.exports = __webpack_public_path__ + "Flama-Ultralight.ttf?95fb245d6b9dcb13e870df120bf1209d";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Ultralight.ttf
// module id = 922
// module chunks = 0